import { render, staticRenderFns } from "./CurrentUserTag.vue?vue&type=template&id=401dc698&scoped=true&"
import script from "./CurrentUserTag.vue?vue&type=script&lang=js&"
export * from "./CurrentUserTag.vue?vue&type=script&lang=js&"
import style0 from "./CurrentUserTag.vue?vue&type=style&index=0&id=401dc698&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401dc698",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VImg})
